import BaseService from '@/network/base-service'

class AgendamentoService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/agendamento`)
  }

  getAgendamentos () {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/agendamento`, {
      method: 'GET'
    })
  }

  getDadosExame (codigoAtendimento) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/agendamento/${codigoAtendimento}`, {
      method: 'GET'
    })
  }

  fetchAgendamentosPDF (payload) {
    return this.get(`pdf?unidade=${payload.unidade}`, {
      responseType: 'blob'
    })
  }

  postConfirmarAtendimento (codigoAtendimento) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/atendimentos/${codigoAtendimento}/confirmar`, {
      method: 'POST'
    })
  }

  postConfirmarVariosAtendimentos (atendimentos) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/atendimentos/confirmarvarios`, {
      method: 'POST',
      body: JSON.stringify(atendimentos),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }

  postRemarcarAtendimentos (atendimentos, motivo, data, converterTeleatendimento, motivoCancelamento) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/atendimentos/remarcar`, {
      method: 'POST',
      body: JSON.stringify({ atendimentos, motivo, data, converterTeleatendimento, motivoCancelamento }),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }

  postConfirmarInternacao (codigoInternacao) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/internacoes/${codigoInternacao}/confirmar`, {
      method: 'POST'
    })
  }
}

export default new AgendamentoService()
